import React, { useState } from 'react'
import NotificationSystem from 'react-notification-system'
const NotificationProvider = React.createContext({})

const NotificationComponent = (props: any) => {
  const [notificationSystem, setNotificationSystem] = useState({})

  return (
    <NotificationProvider.Provider value={notificationSystem}>
      <NotificationSystem
        ref={(node: any) => {
          setNotificationSystem(node)
        }}
      />
      {props.children}
    </NotificationProvider.Provider>
  )
}

const withNotification = (Component: any) => {
  return (props: any) => (
    <NotificationProvider.Consumer>
      {notification => <Component {...props} notification={notification} />}
    </NotificationProvider.Consumer>
  )
}

export { NotificationComponent, NotificationProvider, withNotification }



// WEBPACK FOOTER //
// ./src/components/ui/notification-provider.tsx